// TODO: remove when v1 strips are fully phased out // SIPP-642
import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import { IUser } from '../../../types/User'

interface RequestOptions {
  id: string
  stripVersion: 'v1' | 'v2'
}

export const updateUserStripVersionAsync = createAsyncThunk(
  'users/updateStripVersion',
  async ({ id, stripVersion }: RequestOptions, { rejectWithValue }) => {
    try {
      const response = (await SippApi.update.user(id, { stripVersion })) as AxiosResponse<Partial<IUser>>
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const updateUserStripVersionAsyncBuilder = (builder: any) => {
  builder.addCase(updateUserStripVersionAsync.pending, (state: any) => {
    state.loading = true
    state.error = ''
  })
  builder.addCase(updateUserStripVersionAsync.fulfilled, (state: any, action: any) => {
    state.loading = false
    state.user = { ...state.user, stripVersion: action.payload.stripVersion }
    state.error = ''
  })
  builder.addCase(updateUserStripVersionAsync.rejected, (state: any) => {
    state.loading = false
    state.error = 'Something went wrong'
  })
}
